export const OFFERS_TABLE_COPY = {
  conflictTitle: 'Overlapping live rules',
  conflictBeforeBrands: 'More than one live row targets:',
  conflictAfterBrands: '. Highest rank applies first.',
  bulkTurnOn: 'Turn on',
  bulkPause: 'Pause',
  bulkRemove: 'Remove',
  loadingTitle: 'Fetching rows…',
  loadingHint: 'Filters still apply when results arrive.',
  emptyTitle: 'Nothing matches yet',
  emptyHint: 'Loosen filters or add your first offer for this scope.',
  emptyCta: 'Draft an offer',
  selectAllAria: 'Select every offer on this page',
  thIdType: 'ID / Type',
  thOffer: 'Offer',
  thBrandScope: 'Brand / Scope',
  thRank: 'Rank',
  thStatus: 'Status',
  thActions: 'Actions',
  unnamedOffer: 'Unnamed',
  globalScope: 'Global scope',
  singleBrandScope: 'Single brand',
  togglePauseTitle: 'Pause this offer',
  toggleActivateTitle: 'Turn this offer on',
  statusLive: 'Live',
  statusPaused: 'Paused',
  dateEndedPrefix: 'Ended · ',
  dateEndsPrefix: 'Ends · ',
  actionEditTitle: 'Edit',
  actionDuplicateTitle: 'Duplicate',
  actionRemoveTitle: 'Remove',
  paginationPrevious: 'Previous',
  paginationNext: 'Next',
} as const;

export function selectOfferAriaLabel(offerId: number): string {
  return `Select offer ${offerId}`;
}
